export default __webpack_public_path__ + "static/media/up-arrow-circle.a65a3cd8.svg";